// =============================================================
// PAYMENT SYSTEM TOGGLE
// =============================================================
// Set PAYMENT_ENABLED to true to re-activate the payment system.
// Set PAYMENT_ENABLED to false to disable all payment options.
// =============================================================
export const PAYMENT_ENABLED = false;
